import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { doGetFeatureFlags } from './stores/thunk';
import { selectAllFeatureFlags } from './stores/slice';

export const useFeatureFlags = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(doGetFeatureFlags());
  }, []);

  const rawFeatureFlags = useSelector((state) => selectAllFeatureFlags(state));

  const featureFlags = useMemo(() => {
    if (!rawFeatureFlags || rawFeatureFlags.length === 0) {
      return null;
    }
    return rawFeatureFlags.reduce(
      (acc, f) => ({
        ...acc,
        [f.key]: f.on,
      }),
      {},
    );
  }, [rawFeatureFlags]);

  return { featureFlags };
};
